module.exports = __webpack_public_path__ + "img/eduardoimery.63bb964f.jpg";